import React from 'react';
import { Box, Typography } from '@mui/material';
import Carousel from './Carousel';

const ImageSlide = () => (
  <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 1.5, md: 3 } }}>
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: 4,
        bgcolor: '#fff',
        boxShadow: '0 20px 60px rgba(15,23,42,0.16)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src="/hero.png"
        alt="Smart tracking for predictable, reliable and stress-free service management"
        sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    </Box>
  </Box>
);

const VideoSlide = () => (
  <Box sx={{ position: 'relative', width: '100%', height: '100%', borderRadius: 4, overflow: 'hidden' }}>
    <Box
      component="video"
      autoPlay
      muted
      loop
      playsInline
      disablePictureInPicture
      sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
    >
      <source src="/hero-video.mp4" type="video/mp4" />
    </Box>
  </Box>
);

const HeroSection = () => {
  const slides = [
    { key: 'graphic', content: <ImageSlide /> },
    { key: 'video', content: <VideoSlide /> },
  ];

  return (
    <Box sx={{ px: { xs: 1.5, sm: 3, md: 6 }, pt: { xs: 4, md: 6 }, pb: { xs: 6, md: 10 } }}>
      <Box sx={{ maxWidth: 780, mx: 'auto', textAlign: 'center', mb: { xs: 4, md: 5 } }}>
        <Typography
          variant="h1"
          sx={{ fontWeight: 800, fontSize: { xs: 30, sm: 38, md: 46 }, lineHeight: 1.15, mb: 2 }}
        >
          Track every bill and service, effortlessly
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: { xs: 15, md: 17 }, mb: 1.5 }}>
          Remembr is the free, cloud-based platform that logs service history, sends renewal reminders
          and tracks maintenance costs, for vehicles, home and more.
        </Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 700, fontSize: { xs: 15, md: 17 } }}>
          Never get overcharged twice.
        </Typography>
      </Box>
      <Box
        sx={(theme) => ({
          maxWidth: 1240,
          mx: 'auto',
          borderRadius: 5,
          ...(theme.palette.mode === 'dark'
            ? {
                background:
                  'radial-gradient(120% 140% at 15% 10%, rgba(37,99,235,0.32) 0%, rgba(8,11,20,0) 45%), radial-gradient(90% 120% at 90% 100%, rgba(37,99,235,0.26) 0%, rgba(8,11,20,0) 50%), linear-gradient(180deg, #14161d 0%, #05060a 100%)',
                boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
                p: { xs: 1.5, md: 2.5 },
              }
            : { background: 'transparent' }),
        })}
      >
        <Box sx={{ height: { xs: 420, sm: 480, md: 560 } }}>
          <Carousel slides={slides} ariaLabel="Remembr highlights" />
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
